import * as actionTypes from 'store/actionTypes/loading'

export const startLoading = () => ({ type: actionTypes.START_LOADING })
export const finishLoading = () => ({ type: actionTypes.FINISH_LOADING })
